module.exports = __webpack_public_path__ + "img/close.0139bc5b.png";